module.exports = __webpack_public_path__ + "img/重载AGV.79bdbcd5.jpg";